import EventEmitter from './../core/eventEmitter';
import events       from '../const/events';

export default class BaseState extends EventEmitter {
    constructor() {
        super();
        this.state = {};
    }

    setState(values) {
        this.state = Object.freeze(Object.assign({}, this.state, values));
        this.emit(events.STATE.CHANGED, this.state);
    }
}


// WEBPACK FOOTER //
// ./src/state/base.js